import React, { useState, useEffect } from 'react';

const testimonialsData = [
  {
    id: 1,
    quote:
      'Experts Communication is here to grow your business in every way possible. We know how to use BPO and digital services in the most effective way to bring the best outcomes for the clients.',
    author: 'Axi',
    designation: 'Designation',
    avatar: '/assets/images/hr-manager.jpg'
  },
  {
    id: 2,
    quote:
      'Their inbound call center team transformed our customer retention. Queries are handled within seconds with utmost professionalism, and our CSAT score jumped to 98%.',
    author: 'David Miller',
    designation: 'Head of Operations',
    avatar: '/assets/images/team_member_1.png'
  },
  {
    id: 3,
    quote:
      'Experts Communication delivered top-tier TCPA compliant and MCA leads. The conversion rates exceeded our expectations and our sales pipeline has never been stronger.',
    author: 'Sarah Jenkins',
    designation: 'Director of Growth',
    avatar: '/assets/images/team_member_2.png'
  },
  {
    id: 4,
    quote:
      'Switching our 24/7 technical support to Experts Communication was the best operational decision. Reliable, scalable, and exceptional service delivery every single day.',
    author: 'Marcus Vance',
    designation: 'VP of Customer Success',
    avatar: '/assets/images/team_member_3.png'
  }
];

function BpoTestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide without dots every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
    }, 4200);

    return () => clearInterval(timer);
  }, []);

  const handleExploreClick = (e) => {
    e.preventDefault();
    const servicesSection = document.querySelector('.bpo-tabs-section') || document.querySelector('.services-section');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentTestimonial = testimonialsData[currentIndex];

  return (
    <section className="bpo-testimonial-section">
      <div className="container bpo-testimonial-container">
        {/* Left Column: Headings, Sliding Card, and Button */}
        <div className="bpo-testimonial-left">
          <span className="bpo-testimonial-tag">
            What clients say about us!
          </span>

          <h2 className="bpo-testimonial-title">
            We Handle Everything, From BPO Services to Digital Solutions
          </h2>

          <p className="bpo-testimonial-desc">
            Expert Communication offers BPO services in Karachi. Here is what our clients think about our BPO services.
          </p>

          {/* Testimonial Card (Solid Black with White Text) */}
          <div className="bpo-testimonial-card-wrapper">
            <div className="bpo-testimonial-card" key={currentTestimonial.id}>
              {/* Star Rating */}
              <div className="bpo-stars-row">
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
              </div>

              {/* Review Quote Text */}
              <p className="bpo-quote-text">
                {currentTestimonial.quote}
              </p>

              {/* Client Info & Big Stylized Quote Icon */}
              <div className="bpo-client-row">
                <div className="bpo-client-info">
                  <img 
                    src={currentTestimonial.avatar} 
                    alt={currentTestimonial.author} 
                    className="bpo-client-avatar"
                  />
                  <div className="bpo-client-details">
                    <h4 className="bpo-client-name">{currentTestimonial.author}</h4>
                    <span className="bpo-client-role">{currentTestimonial.designation}</span>
                  </div>
                </div>

                {/* Quotation Symbol */}
                <div className="bpo-quote-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2H4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2h-4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button className="btn-bpo-explore" onClick={handleExploreClick}>
            Explore Services
          </button>
        </div>

        {/* Right Column: High-Tech 5-Star Reviews Showcase Image */}
        <div className="bpo-testimonial-right">
          <div className="bpo-reviews-img-wrapper">
            <img 
              src="/assets/images/bpo_reviews_neon.jpg" 
              alt="5-Star Reviews Customer Showcase" 
              className="bpo-reviews-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default BpoTestimonialsSlider;
